/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={disableDelayMs:2e3};export{e as meshAutoFastUpdateConstants};
